
import React, { useState, useEffect } from 'react';
import '../styles/paginated.css'
import DynamicIcon from './dynamicicon';

function Pagenated({maxPage,total,onPick,size, onChangePageSize, pageNo=1}) {
    const [staySigned, setStaySigned] = useState(false)
    
    const [pages, setPages]=useState([]);
    const [pos, setPos] = useState(1);
    const [maxEntry, setMaxEntry] = useState(0);

    
    useEffect(() => { 
       
        var k=0;
       var  _pages=[];
        var page=pageNo;
       // let maxPage=8;
        while(k<total){

            if(page<=maxPage){
                _pages.push({id:page,text:page, selected:false});
                page++;
                k=k+size; //size of each page
            }else{
                _pages.push({id:0,text:"Next", selected:false},{id:100,text:'Previous', selected:false});
               
                break;
            }
            
        }
        console.log(_pages);
        setPages(_pages);
        const maxEntries= Math.min(size * pos, total);
        setMaxEntry(maxEntries);
        setPos(pageNo);
     }, [maxPage,total,pageNo]);

     const onSelect=(f)=>{
      if(f.id==0){
        //last next one
        return
      }
      if(f.id==100){
        //last previous one
        return
      }
        onPick(f);
        setPos(f.id);
     }
     const onChangeSize=(e)=>{
      onChangePageSize(e.target.value);
     }

     const onPrevious=()=>{

      if(pos>1){
        const npage=pos-1;
        onPick({id:npage,text:'next'});
        setPos(npage);
        console.log(npage)
        const maxEntries= Math.min(size * npage, total);
        setMaxEntry(maxEntries);
      }
       
     }

     const onNext=()=>{
     const maxEntries= Math.min(size * pos, total);
     if(total>=maxEntries){
        const npage=pos+1;
        onPick({id:npage,text:'next'});
        setPos(npage);
        console.log(npage)
        setMaxEntry(Math.min(size * npage, total));
     }
     
     
       
     }

  return (
    <div style={{ flex:1, width:'100%'}}>
  
    <div  className='pagenate-new'>
     <div className='p-part-1'>
      <span>Show</span>  
      <select value={size} onChange={onChangeSize} >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
          <option value="60">60</option>
          <option value="70">70</option>
          <option value="80">80</option>
          <option value="90">90</option>
          <option value="100">100</option>
      </select>
      <span>Entries</span>
      <span>Showing {pos==1?1: (size*(pos-1))} - {Math.min(size * pos, total)} of {total} entries</span>
      </div>
     <div className='p-part-2'>
     {pos>1 && <div onClick={onPrevious}><DynamicIcon iname="chevron-left" /> <span>Previous</span> </div>} 
    {total>maxEntry && <div onClick={onNext}><span>Next</span>  <DynamicIcon iname="chevron-right" /> </div>}  
     </div>
     
      
      {/* {pages.map((item, idx) =>{return (
        <div className={pos==item.id?'active':''} key={idx} value={item.id} onClick={()=>onSelect(item)}>{item.text}</div>
      )})} */}
      
    
    </div>
    
</div>
  )
}

export default Pagenated